
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 437 500"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M124.1 122.6c7.8 10.3 5.7 25-4.7 32.8-40.2 30.2-66.1 78.2-66.1 132.4 0 91.3 74 165.4 165.2 165.4s165.2-74 165.2-165.4c0-54.1-25.9-102.1-66.1-132.4-10.3-7.8-12.4-22.4-4.7-32.8 7.8-10.3 22.4-12.4 32.8-4.7 51.4 38.6 84.8 100.3 84.8 169.8 0 117.2-94.9 212.3-212 212.3s-212-95-212-212.3c0-69.5 33.3-131.1 84.8-169.8 10.4-7.7 25-5.6 32.8 4.7z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M218.6 0C231.5 0 242 10.5 242 23.4v151.1c0 12.9-10.5 23.4-23.4 23.4s-23.4-10.5-23.4-23.4V23.4C195.1 10.5 205.6 0 218.6 0z"}})])
          )
        }
      }
    